// Local-first read helper.
//
// Wraps a REST call so it serves from the SQLite cache when there is one, and
// falls through to the network otherwise. The wrapper returns the SAME
// axios-like `{ data }` shape the raw call returns, so no caller changes.
//
// FALLBACK RULE (matching the Dart): fall through to REST when the cache
// returns null (unavailable / query failed) OR an empty list. An empty list is
// treated as "not cached" rather than "genuinely nothing", because that is what
// Flutter does — the cost is that a genuinely empty room re-asks the server each
// time, which is a fair trade against showing an empty room that isn't.
//
// On web/desktop `dbSupported()` is false and this is a pass-through, so the
// desktop UI keeps reading REST directly with no extra work per call.

import { dbSupported } from '../db/schema';

export async function localFirst(readLocal, readRest) {
  if (dbSupported()) {
    try {
      const rows = await readLocal();
      if (rows && rows.length) return { data: rows };
    } catch (e) {
      // fall through to REST
    }
  }
  return readRest();
}

// Same, for endpoints that return a single row wrapped in an array.
export async function localFirstOne(readLocal, readRest) {
  if (dbSupported()) {
    try {
      const row = await readLocal();
      if (row) return { data: [row] };
    } catch (e) {
      // fall through to REST
    }
  }
  return readRest();
}
